module.exports = __webpack_public_path__ + "assets/img/90ce6afd0169b0aa124dc662c5786317.png";